import { createRouteRef } from '@backstage/core-plugin-api';

export const storybookRouteRef = createRouteRef({
  id: 'storybook',
});
